import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const LaborInBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="border-transparent bg-indigo-500 font-semibold text-white">
      {t('component:badge.transferringIn')}
    </Badge>
  );
};
